import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useWindowWidth } from 'src/hooks/useWindowWidth';
import { AvailableFilters } from 'src/types/marketplace';
import { getFilterKeyMobile } from 'src/utils/marketplace/filter';

import { DesktopFilters } from '../DesktopFilters';

type Props = {
  availableFilters: AvailableFilters;
};

export function Filters({ availableFilters }: Props) {
  const { register, unregister } = useFormContext();

  const {
    windowWidth,
    breakpoints: { MD },
  } = useWindowWidth();

  useEffect(() => {
    const filterBlocks = availableFilters.map(({ filterKey }) => filterKey);

    filterBlocks.forEach((filterKey) => {
      register(filterKey, { value: [] });
      register(getFilterKeyMobile(filterKey), { value: [] });
    });

    return () => {
      filterBlocks.forEach((filterKey) => {
        unregister(filterKey);
        unregister(getFilterKeyMobile(filterKey));
      });
    };
  }, [availableFilters, register, unregister]);

  return availableFilters.length && windowWidth && windowWidth > MD ? (
    <DesktopFilters availableFilters={availableFilters} />
  ) : null;
}
